/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable @typescript-eslint/no-use-before-define */
/**
 *
 * Component: DateSelectionFilter
 * Date: 13/8/2020
 *
 */

import React, { useState, useRef } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import mixpanel from 'utils/mixpanel';

// eslint-disable-next-line import/no-extraneous-dependencies
import { RangeValue } from 'rc-picker/lib/interface';
import { Icon, Button, Text } from '../common';
import { FilterLayout } from '../index';
// import {
//   StringConstants,
//   dateTime,
//   dateTimeMinusFormatter,
//   dateTimeFormat,
// } from 'utils/commonFunctions';

import styles from './style.module.css';

const { RangePicker } = DatePicker as any;
const options = [
  { _id: '1', name: 'Last 1 day' },
  { _id: '3', name: 'Last 3 days' },
  { _id: '7', name: 'Last 7 days' },
  { _id: '30', name: 'Last 1 Month' },
  { _id: '90', name: 'Last 3 Months' },
];
const DateSelectionFilter = ({
  selectedValues,
  filter,
  onFilterApplied,
  handleClear,
  range,
  moreFilter,
}: any) => {
  const dateSelectionFilterRef = useRef<any>();
  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [closePicker, setClosePicker] = useState(
    !!(_.isEmpty(selectedValues) || typeof selectedValues === 'string'), // TODO: !! might be meaningless here.
  );

  /**
   * Event Handler for firing on applying filter.
   */
  const onChange = (
    field: any,
    selectedDates: string | RangeValue<moment.Moment>,
    customField = false,
  ) => {
    onFilterApplied(field, selectedDates);
    if (customField) {
      if (closePicker) {
        handleClickOutside();
      }
      setClosePicker(!closePicker);
    } else if (filter.field === field) {
      handleClickOutside();
    }

    // Mixpanel update.
    let dateSelected = {};
    if (_.isArray(selectedDates)) {
      if (selectedDates.length === 2)
        dateSelected = {
          start: moment(selectedDates[0]).format('YYYY-MM-DD'),
          end: moment(selectedDates[1]).format('YYYY-MM-DD'),
        };
      else dateSelected = selectedDates;
    } else dateSelected = `${selectedDates} days`;

    mixpanel('Date Select', 'Insights', {
      userId: `${localStorage.getItem('userEmail')}`,
      dateSelected,
    });
  };

  /**
   * Returns a formatted filter-name for the button.
   * @returns {String}
   */
  const getButtonName = () => {
    let filterName = filter ? filter.name : '';
    if (
      typeof selectedValues !== 'string' &&
      (!selectedValues || selectedValues?.length < 2)
    ) {
      return filterName;
    }
    if (filter.customField && typeof selectedValues === 'string') {
      filterName =
        options.find((value) => value._id === selectedValues)?.name ||
        filterName;
    } else {
      let startDate = selectedValues[0];

      startDate = moment(startDate);
      let endDate = selectedValues[1];
      endDate = moment(endDate);
      if (selectedValues) {
        if (moment(startDate).diff(endDate, 'days') <= 1) {
          if (endDate.diff(startDate, 'days')) {
            filterName = `${startDate.format('DD MMM')} - ${endDate.format(
              'DD MMM',
            )}`;
          } else {
            filterName = startDate.format('DD MMM');
          }
        } else {
          filterName = `${moment(selectedValues[0]).format(
            'MM/DD/YY',
          )} - ${moment(selectedValues[1]).format('MM/DD/YY')}`;
        }
      }
    }

    return filterName;
  };

  /**
   *  On outside click remove the filter options, dateRangePicker and remove the listener for mousedown event.
   */
  const handleClickOutside = () => {
    setShowFilter(false);
    setShowDateRangePicker(false);
    handleListener(false);
  };

  /**
   * Listener setter, based on bool.
   * @param {Boolean} bool
   */
  const handleListener = (bool: boolean) => {
    if (bool) {
      document.addEventListener('mousedown', handleClickEvent);
    } else {
      document.removeEventListener('mousedown', handleClickEvent);
    }
  };

  /**
   * Only handles to detect whether an outside click detected, from dateSelectionFilter component.
   * @param {HTMLElement} e
   */
  const handleClickEvent = (e: any) => {
    const path = e.path || (e.composedPath && e.composedPath());
    if (
      !path.includes(dateSelectionFilterRef.current) &&
      !(
        document.getElementsByClassName('myDatePicker').length > 0 &&
        document
          .getElementsByClassName('myDatePicker')[0]
          .innerHTML.includes(e.target.className)
      )
    ) {
      handleClickOutside();
    }
  };

  /**
   * Returns JSX for RangePicker UI and based on custom variable, operates on filter values
   * for either customField key (if true) or field key (if false)
   * @param {Boolean} custom
   * @returns {JSX}
   */
  const getCustomComponent = (custom = false) => {
    // let primaryTimezone = localStorage.getItem('timezone');
    // primaryTimezone = primaryTimezone || StringConstants.defaultTimezone;
    let newSelectedValues;
    if (typeof selectedValues !== 'string' && selectedValues.length > 1) {
      newSelectedValues = selectedValues.map(
        (newSelectedValue: any) => moment(newSelectedValue), // A Date Time Parser Library for multiple selectedValues.
      );
    }
    //  else {
    // let today = dateTime(undefined, undefined, primaryTimezone);
    // const yesterday = dateTimeMinusFormatter(today, 'MM/dd/uuuu', 1);
    // today = dateTimeFormat(today, 'MM/dd/uuuu');
    // newSelectedValues = [
    //   moment(yesterday, 'MM/DD/YYYY'),
    //   moment(today, 'MM/DD/YYYY'),
    // ];
    //   newSelectedValues = null;
    // }
    return (
      showDateRangePicker && (
        <div className={styles.datePicker}>
          <RangePicker
            defaultPickerValue={range && range.max ? moment(range.max) : null}
            disabledDate={(current: any) => {
              if (range) {
                return (
                  current < moment(range.min) || current > moment(range.max)
                );
              }
              if (filter.fullRange) {
                return false;
              }
              if (filter.disablePrevious) {
                return current <= moment();
              }
              return current > moment();
            }}
            value={newSelectedValues}
            dropdownClassName="myDatePicker"
            format="YYYY-MM-DD"
            open
            placeholder={['Start Date', 'End date']}
            onChange={(e: any) => {
              return onChange(
                custom ? filter.customField : filter.field,
                e,
                true,
              );
            }}
          />
        </div>
      )
    );
  };

  /**
   * If filter owns subtype as customDate string, returns a FilterLayout else the RangePickerUI from getCustomComponent.
   * @returns {JSX}
   */
  const getDateComponent = () => {
    if (filter.subtype === 'customDate') {
      return (
        showFilter && (
          <FilterLayout>
            <div className={styles.filterComponent}>
              {options.map((filterDetail) => (
                <div
                  role="button"
                  aria-hidden="true"
                  onClick={() => onChange(filter.field, filterDetail._id)}
                  className={`${styles.filterOption} ${
                    selectedValues === filterDetail._id
                      ? styles.filterOptionSelected
                      : ''
                  }`}
                  key={filterDetail._id}
                >
                  <Text
                    type="paragraphLarge"
                    className="thin"
                    text={filterDetail.name}
                  />
                </div>
              ))}
              <div
                role="button"
                aria-hidden="true"
                onClick={() => setShowDateRangePicker(true)}
                className={styles.customDate}
              >
                <Text type="paragraphLarge" className="thin" text="Custom" />
                {getCustomComponent(true)}
              </div>
            </div>
          </FilterLayout>
        )
      );
    }
    return getCustomComponent();
  };

  return (
    <div className={styles.container}>
      <div>
        <div ref={dateSelectionFilterRef} id="dateFilterId">
          <div className={styles.filterContent}>
            {moreFilter && <Text type="subtitle" text={filter?.name} />}
            <div className="grid-column">
              <div className="filter-button">
                <Button
                  height="25px"
                  type={
                    !selectedValues ||
                    (typeof selectedValues === 'object' &&
                      selectedValues.length < 2)
                      ? 'chips-secondary'
                      : 'chips'
                  }
                  onClick={() => {
                    if (filter.subtype === 'customDate') {
                      setShowFilter(!showFilter);
                    } else {
                      setShowDateRangePicker(!showDateRangePicker);
                    }
                    if (!showDateRangePicker) handleListener(true);
                    mixpanel('Date Dropdown', 'Insights', {
                      userId: `${localStorage.getItem('userEmail')}`,
                    });
                  }}
                >
                  {getButtonName()}
                </Button>
              </div>
              {selectedValues?.length > 0 && moreFilter && !filter.customField && (
                <Icon
                  size={12}
                  onClick={() => handleClear(filter.field)}
                  type="delete"
                />
                // eslint-disable-next-line @typescript-eslint/indent
              )}
            </div>

            {getDateComponent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateSelectionFilter;
